import React from 'react';
import classNames from 'classnames';
import Button from "../form/Button";
import PropTypes from "prop-types";
import connectAdvanced from "react-redux/es/components/connectAdvanced";
import {bindActionCreators} from "redux";
import {setBoxState} from "../../actions";
import {store} from "../../store";

class DefaultBox extends React.Component {

    static propTypes = {
        width: PropTypes.any,
        collapsed: PropTypes.bool,
        theme: PropTypes.string,
        header: PropTypes.any,
        actions: PropTypes.any,
        body: PropTypes.any,
		footer: PropTypes.any,
		boxid: PropTypes.string,
    }

	state = {}

    setPersistenceState = (state, cb) => {
        this.setState(state, () => {
            if (this.props.boxid) {
                this.props.setBoxState(this.props.boxid, this.state);
            }
            cb && cb();
        });
    }

	constructor(props) {
		super(props);
        const stored = props.boxid ? store.getState().boxes[props.boxid] : null;
		this.state.collapsed = stored ? stored.collapsed : this.props.collapsed;
	}

	componentDidUpdate(prevProps, prevState, prevContext) {
		if(prevProps.collapsed !== this.props.collapsed) {
			this.setPersistenceState({
				collapsed: this.props.collapsed
			});
		}
	}

    toggleCollapse = () => {
        if(this.state.collapsed !== undefined) {
            this.setPersistenceState({
                collapsed: !this.state.collapsed
            })
        }
	}

	focus = () => {
		this.el.focus();
	}

	render() {
		return (
            <div
                ref={(el) => this.el = el}
                tabIndex={0}
                className={classNames("box box-"+(this.props.theme || "default"), {
                    "collapsed-box": this.state.collapsed === true
                })}
            >
                {
                    (this.props.header || this.state.collapsed !== undefined || this.props.actions) &&
                    <div
                        className={classNames("box-header with-border", {"clickable": !this.props.actions && this.state.collapsed !== undefined})}
                        onClick={!this.props.actions && this.state.collapsed !== undefined ? this.toggleCollapse : null}
                    >
                        {this.props.header}
                        &nbsp;
                        {(this.state.collapsed !== undefined || this.props.actions) && <div className="box-tools pull-right">
                            {!!this.props.actions && <div className="box-actions">{this.props.actions}</div>}
                            {this.state.collapsed !== undefined && <Button onClick={this.toggleCollapse} type="button" className="btn btn-box-tool" data-widget="collapse" icon={{lib: "fa", name: classNames({"minus": !this.state.collapsed, "plus": this.state.collapsed})}} />}
                        </div>}
                    </div>
                }
                <div className="box-body">
                    {this.props.body || this.props.children}
                </div>
                {
                    this.props.footer && ((Array.isArray(this.props.footer) && !!this.props.footer.length) || !Array.isArray(this.props.footer)) &&
                    <div className="box-footer">
                        {this.props.footer}
                    </div>
                }
            </div>
		);
	}
}

export default class Box extends React.Component {

    static propTypes = DefaultBox.propTypes;

    constructor(props) {
        super(props);
        this.Connected = connectAdvanced((dispatch) => {
            return (store, nextOwnProps) => {
                const actions = bindActionCreators({setBoxState}, dispatch);
                return {
                    ...nextOwnProps,
                    ...actions
                }
            }
        },{forwardRef: true})(DefaultBox);
    }

    focus = () => {
        this.c && this.c.focus();
    }

    toggleCollapse = () => {
        this.c && this.c.toggleCollapse();
    }

    render () {
        const Component = this.Connected;
        return <Component ref={(c) => this.c = c} {...this.props}/>;
    }

}